import { createStore, applyMiddleware, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import apiReducer from './apiDuck';
import carReducer from './carDuck';
import personReducer from './personDuck';
import quoteReducer from './quoteDuck';
import thunk from 'redux-thunk';
import { loadState, saveState } from './localStorage';

const persistedState = loadState();

const rootReducer = combineReducers({
  api: apiReducer,
  car: carReducer,
  person: personReducer,
  quote: quoteReducer
});

export const store = createStore(rootReducer, persistedState, composeWithDevTools(applyMiddleware(thunk)));

store.subscribe(() => {
  saveState({
    api: store.getState().api,
    car: store.getState().car,
    person: store.getState().person,
    quote: store.getState().quote
  });
});
